module.exports = __webpack_public_path__ + "img/game01.4a8262ab.jpg";